import React from 'react'
import Headersm from '../component/Headersm'
import Displayphone from '../component/Displayphone'
import Categories from '../component/Categories'
import Electronicbrand from '../component/Electronicbrand'
import Essential from '../component/Essential'
import { Footer } from '../component/Footer1'
import Bigscreenheader from '../component/Bigscreenheader'


const Homepage = () => {
  return (
    <div >
      <Bigscreenheader/>
      <Headersm/>
      <header>
        <div id='bg-text-container'>
<h5 style={{color:'white',textAlign:'left'}}>Best Deal online on Smart watches </h5>
<h1 style={{color:'white',textAlign:'left'}}>SMART WEARABLE. </h1>
<h5 style={{color:'white',textAlign:'left'}}>UP to 80% OFF</h5>
        </div>

        <div id='bg-image-container'>
<img src="/asset/Watch Ultra.png" alt="" />
        </div>
      </header>
<Displayphone/>
<Categories/>
<Electronicbrand/>
<Essential/>
<Footer/>
    </div>
  )
}

export default Homepage